/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VcdsPeerDeployment } from './vcdsPeerDeployment';


export interface VcdsDeploymentInventoryTree { 
    peer_deployment?: Array<VcdsPeerDeployment>;
}

